export const ERROR_CODES = {
  AlreadyExists: 'ALREADY_EXISTS',
  BadUserInput: 'BAD_USER_INPUT',
  FailedPrecondition: 'FAILED_PRECONDITION',
  Forbidden: 'FORBIDDEN',
  InternalServerError: 'INTERNAL_SERVER_ERROR',
  NotFound: 'NOT_FOUND',
  RateLimitExceeded: 'RATE_LIMIT_EXCEEDED',
  RequestTimeoutError: 'REQUEST_TIMEOUT_ERROR',
  Unauthenticated: 'UNAUTHENTICATED',
  Unauthorized: 'UNAUTHORIZED',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
